import React, { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import api from "../../Utils/api";

// Custom switch component
function ToggleSwitch({ checked, onChange }) {
  return (
    <button
      type="button"
      className={`relative inline-flex items-center w-14 h-7 rounded-full transition-colors focus:outline-none ${
        checked ? "bg-gray-600" : "bg-gray-200"
      }`}
      onClick={() => onChange(!checked)}
      aria-pressed={checked}
    >
      <span
        className={`absolute left-1 top-1 w-5 h-5 rounded-full bg-white shadow transition-transform ${
          checked ? "translate-x-7" : ""
        }`}
      />
      <span
        className={`ml-auto  text-xs font-semibold ${
          checked ? "text-white mr-8" : "mr-2 text-gray-600"
        }`}
      >
        {checked ? "ON" : "OFF"}
      </span>
    </button>
  );
}

export function DuplicateLocation({
  id,
  open,
  onClose,
  locationName,
  getLocations,
}) {
  const [newName, setNewName] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [copyEmployees, setCopyEmployees] = useState(true);
  const [copySettings, setCopySettings] = useState(true);
  const [copyPayroll, setCopyPayroll] = useState(true);
  const [copyShifts, setCopyShifts] = useState(true);

  if (!open) return null;

  const duplicateLocation = async () => {
    const res = await api.post("/location/duplicate", {
      targetLocationID: id,
      name: newName,
      address: newAddress,
    });

    if (res.data.success) {
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message);
    }

    // TODO : reload locations
    getLocations();
    onClose();
  };

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-7 relative">
        {/* Close button */}
        <button
          className="absolute top-5 right-5 text-2xl text-gray-600"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-7">
          Duplicate {locationName}
        </h2>
        {/* Form */}
        <div className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              New Location Name
            </label>
            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Enter name of the new location"
              className="w-full px-4 py-2 border-gray-300 rounded-lg bg-gray-200 text-gray-700"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              Address
            </label>
            <input
              type="text"
              value={newAddress}
              onChange={(e) => setNewAddress(e.target.value)}
              className="w-full px-4 py-2 border-gray-300 rounded-lg bg-gray-200 text-gray-700"
            />
          </div>
          {/* Switches */}
          {/* <div className="flex items-center justify-between">
            <span className="text-gray-600">Copy Employees</span>
            <ToggleSwitch checked={copyEmployees} onChange={setCopyEmployees} />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-600">Copy Settings</span>
            <ToggleSwitch checked={copySettings} onChange={setCopySettings} />
          </div> */}
          {/* <div className="flex items-center justify-between">
            <span className="text-gray-600">Copy Payroll Connection</span>
            <ToggleSwitch checked={copyPayroll} onChange={setCopyPayroll} />
          </div> */}
          {/* <div className="flex items-center justify-between">
            <span className="text-gray-600">Copy Shift Templates</span>
            <ToggleSwitch checked={copyShifts} onChange={setCopyShifts} />
          </div> */}
        </div>
        {/* Footer */}
        <div className="flex justify-end mt-8 gap-3">
          <button
            className="px-6 py-2 rounded-lg text-gray-600 bg-white font-semibold hover:bg-[#F7F6FB] border border-transparent hover:border-[#E7E4F8] transition"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-6 py-2 rounded-lg text-white bg-gray-600 font-semibold hover:bg-gray-700 transition"
            onClick={duplicateLocation}
          >
            Duplicate!
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
